"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PermissionItem = void 0;
/**
 * Revoked permissions.
 */
class PermissionItem {
    constructor(json) {
        Object.assign(this, json);
    }
}
exports.PermissionItem = PermissionItem;
(function (PermissionItem) {
    PermissionItem.TypeEnum = {
        AUTHENTICATE: 'AUTHENTICATE',
        ADMIN: 'ADMIN',
        PATIENTVIEW: 'PATIENT_VIEW',
        PATIENTCREATE: 'PATIENT_CREATE',
        PATIENTCHANGEDELETE: 'PATIENT_CHANGE_DELETE',
        MEDICALDATAVIEW: 'MEDICAL_DATA_VIEW',
        MEDICALDATACREATE: 'MEDICAL_DATA_CREATE',
        MEDICALCHANGEDELETE: 'MEDICAL_CHANGE_DELETE',
        FINANCIALDATAVIEW: 'FINANCIAL_DATA_VIEW',
        FINANCIALDATACREATE: 'FINANCIAL_DATA_CREATE',
        FINANCIALCHANGEDELETE: 'FINANCIAL_CHANGE_DELETE',
    };
})(PermissionItem = exports.PermissionItem || (exports.PermissionItem = {}));
//# sourceMappingURL=PermissionItem.js.map